import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import { useState } from "react";
import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import "./App.css";
import { BasicForm } from "./BasicForm";
import { AddColor } from "./color/AddColor";
import { AddMovie } from "./movies/AddMovie";
import { EditMovie } from "./movies/EditMovie";
import { MovieDetails } from "./movies/MovieDetails";
import { MovieList } from "./movies/MovieList.js";
import { NotFound } from "./NotFound";
import { Welcome } from "./Welcome.1";

function App() {
  const history = useHistory();

  const [mode, setMode] = useState("dark");

  // 1. creating context
  const theme = createTheme({
    palette: {
      mode: mode,
    },
  });

  // console.log("selectedmovie");

  // useEffect(() => {
  //   async function getMovies() {
  //     const data = await fetch(
  //       "https://60c98aa8772a760017203b57.mockapi.io/movies",
  //       {
  //         method: "GET",
  //       }
  //     ); // returns a promise object
  //     const mvs = await data.json();
  //     setMovies(mvs);
  //   }

  //   getMovies();
  // }, []);

  const paperStyles = { borderRadius: 0, minHeight: "100vh" };

  return (
    // 2. Publisher Provider
    <ThemeProvider theme={theme}>
      <Paper elevation={4} style={paperStyles}>
        <div className="App">
          <AppBar position="static">
            <Toolbar>
              <Button
                onClick={() => history.push("/")}
                size="large"
                color="inherit"
                aria-label="home"
              >
                Home
              </Button>
              <Button
                onClick={() => history.push("/movies")}
                size="large"
                color="inherit"
                aria-label="home"
              >
                Movies
              </Button>
              <Button
                onClick={() => history.push("/movies/add")}
                size="large"
                color="inherit"
                aria-label="home"
              >
                Add movie
              </Button>
              <Button
                onClick={() => history.push("/color-game")}
                size="large"
                color="inherit"
                aria-label="home"
              >
                Color game
              </Button>

              <Button
                onClick={() => history.push("/basic-form")}
                size="large"
                color="inherit"
                aria-label="home"
              >
                Basic form
              </Button>

              <Button
                style={{ marginLeft: "auto" }}
                onClick={() => setMode(mode === "light" ? "dark" : "light")}
                size="large"
                color="inherit"
                aria-label="home"
                startIcon={
                  mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />
                }
              >
                {mode === "light" ? "dark" : "light"} mode
              </Button>
            </Toolbar>
          </AppBar>

          <Switch>
            <Route exact path="/">
              <Welcome />
            </Route>

            {/* /films -> /movies */}
            {/* DRY */}
            {/* old /films /movies new */}

            <Route path="/films">
              <Redirect to="/movies" />
            </Route>

            {/* If data need to be shared, then put it in their common parent component */}

            <Route path="/movies/add">
              <AddMovie />
            </Route>

            <Route path="/movies/edit/:id">
              <EditMovie />
            </Route>

            <Route path="/movies/:id">
              <MovieDetails />
            </Route>

            <Route path="/movies">
              {/* copy of movies & then add the new movie to it*/}
              {/* <button ></button> */}

              <MovieList />
            </Route>
            <Route path="/color-game">
              <AddColor />
            </Route>
            <Route path="/basic-form">
              <BasicForm />
            </Route>
            <Route path="**">
              <NotFound />
            </Route>
          </Switch>
        </div>
      </Paper>
    </ThemeProvider>
  );
}

// 3. Subscribing - useContext

export default App;
// Task
// Dark mode for Movie app
// C - Create - POST - Done
// R - Read - GET - Done
// U - Update - PUT - Task - GET + POST - Done
// D - Delete - DELETE -Done
